<script setup>
import {inject} from 'vue'
import Tabs from "@/components/common/navigation/tabs/Tabs";
import TabsContent from "@/components/common/navigation/tabs/TabsContent";
import DetailedInformation from "@/components/shipments/DetailedInformation";
import CollectionDelivery from "@/components/shipments/CollectionDelivery";
import Containers from "@/components/shipments/Containers";
import Customs from "@/components/shipments/Customs";
import NoDataFoundBanner from "@/components/shipments/NoDataFoundBanner";
import WarehouseShipmentDetail from "@/components/warehouse/WarehouseShipmentDetail";
import WarehouseItemDetails from"@/components/warehouse/WarehouseItemDetails"
import Modal from "@/components/common/other/Modal";

import {computed} from "@vue/reactivity";

const shipments = inject("shipments");

const showContainers = computed(() => {


  if(shipments.value.viewShipment.mode.toLowerCase() === shipments.value.modes.sea.toLowerCase()) {
    return true;

  } else {
    shipments.value.selectedViewShipmentTab = 'Detailed Information';
    return false
  }

});

</script>

<template class="cmp-view-shipment-tabs-area">
  <div id="Vue-3-component-view-shipment-tabs-area" class="cmp-view-shipment-tabs-area_tabs-wrapper">
    <Tabs v-model:selectedTab="shipments.selectedViewShipmentTab" :key="shipments.viewShipment.mode">
      <TabsContent
          icon="fa-duotone fa-memo-circle-info"
          iconColor="#767676"
          name="Detailed Information"
          :selectedTab="shipments.selectedViewShipmentTab">
        <DetailedInformation></DetailedInformation>
      </TabsContent>
      <TabsContent
          icon="fa-duotone fa-warehouse"
          iconColor="#767676"
          name="Warehouse"
          :selectedTab="shipments.selectedViewShipmentTab">
        <WarehouseShipmentDetail></WarehouseShipmentDetail>
      </TabsContent>
      <TabsContent
          v-if="showContainers"
          icon="fa-regular fa-container-storage"
          iconColor="#767676"
          name="Containers"
          :selectedTab="shipments.selectedViewShipmentTab">
        <Containers></Containers>
<!--        <div v-else class="cmp-view-shipment-tabs-area_incorrect-mode">-->
<!--          <NoDataFoundBanner>Not Applicable For this Mode</NoDataFoundBanner>-->
<!--        </div>-->
      </TabsContent>
      <TabsContent
          icon="fa-duotone fa-passport"
          iconColor="#767676"
          name="Customs"
          :selectedTab="shipments.selectedViewShipmentTab">
        <Customs></Customs>
      </TabsContent>
      <TabsContent
          icon="fa-duotone fa-truck-ramp-box"
          iconColor="#767676"
          name="Pickup / Delivery"
          :selectedTab="shipments.selectedViewShipmentTab">
          <CollectionDelivery></CollectionDelivery>
      </TabsContent>
    </Tabs>
  </div>
  <Modal
      v-model="shipments.warehousePicksModal"
      title="Warehouse Item Details"
      width="1680px"
      height="480px">
    <template #icon>
      <i class="fa-solid fa-warehouse-full" style="color: #F68E1E; font-size: 20px"></i>
    </template>
    <template #body>
      <WarehouseItemDetails></WarehouseItemDetails>
    </template>
  </Modal>

</template>

<style lang="scss" scoped>

.cmp-view-shipment-tabs-area {

  &_incorrect-mode {
    margin-top: 50px;
  }

  &_tabs-wrapper {
    margin-top: 20px;
  }

}

</style>
